import { render, staticRenderFns } from "./onlineTab.vue?vue&type=template&id=140ae5f0&scoped=true"
import script from "./onlineTab.vue?vue&type=script&lang=js"
export * from "./onlineTab.vue?vue&type=script&lang=js"
import style0 from "./onlineTab.vue?vue&type=style&index=0&id=140ae5f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ae5f0",
  null
  
)

export default component.exports